import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing an icon to show all vehicles on the map.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ShowAllVehiclesIcon width={12} />
 */
const ShowAllVehiclesIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M5.71,37.71l4.59,4.59A1,1,0,0,1,9.59,44H5a1,1,0,0,1-1-1V38.41A1,1,0,0,1,5.71,37.71ZM4,5V9.59a1,1,
                0,0,0,1.71.71l4.59-4.59A1,1,0,0,0,9.59,4H5A1,1,0,0,0,4,5Zm33.71.71,4.59,4.59A1,1,0,0,0,44,9.59V5a1,
                1,0,0,0-1-1H38.41A1,1,0,0,0,37.71,5.71ZM36,24.8V32a1.2,1.2,0,0,1-1.2,1.2H32.4A1.2,1.2,0,0,1,31.2,
                32h0V30.8H16.8V32a1.2,1.2,0,0,1-1.2,1.2H13.2A1.2,1.2,0,0,1,12,32h0V24.8a5.85,5.85,0,0,1,
                1.2-3.6l.8-.78a3,3,0,0,0,.61-1L16,15.08a3.56,3.56,0,0,1,3.2-2.28h9.6A3.57,3.57,0,0,1,32,15.08l1.45,
                4.35a2.92,2.92,0,0,0,.61,1l.74.77A5.85,5.85,0,0,1,36,24.8Zm-19.2.6A1.8,1.8,0,1,0,15,27.2,1.8,1.8,
                0,0,0,16.8,25.4Zm12,2.4a.6.6,0,0,0-.6-.6H19.8a.6.6,0,0,0,0,1.2h8.4a.6.6,0,0,0,.6-.6ZM31.73,20a.3.3,
                0,0,0,.19,0,.41.41,0,0,0,.21-.54l-1.32-4a2.38,2.38,0,0,0-2-1.46h-9.6a2.38,2.38,0,0,0-2,1.46l-1.32,
                4a.34.34,0,0,0,0,.2.4.4,0,0,0,.43.37H31.73Zm3.07,5.4A1.8,1.8,0,1,0,33,27.2,1.8,1.8,0,0,0,34.8,25.4ZM44,
                43V38.41a1,1,0,0,0-1.71-.71l-4.59,4.59A1,1,0,0,0,38.41,44H43A1,1,0,0,0,44,43Z`}
        />
    </SvgIcon>
)

ShowAllVehiclesIcon.defaultProps = defaultProps

export { ShowAllVehiclesIcon }
